import React from 'react';

interface FilterIconProps {
    width?: number;
    height?: number;
    stroke?: string;
    strokeWidth?: number;
    className?: string;
}

export default function FilterIcon({ 
    width = 24, 
    height = 24, 
    stroke = 'black', 
    strokeWidth = 1.5,
    className 
}: FilterIconProps) {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width={width} 
            height={height} 
            viewBox="0 0 24 24" 
            fill="none"
            className={className}
        >
            <path 
                d="M18 4L21 7L18 10M18 20L21 17L18 14" 
                stroke={stroke} 
                strokeWidth={strokeWidth} 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M3 7H6C7.32608 7 8.59785 7.52678 9.53553 8.46447C10.4732 9.40215 11 10.6739 11 12C11 13.3261 11.5268 14.5979 12.4645 15.5355C13.4021 16.4732 14.6739 17 16 17H21M21 7H16C14.9179 6.99855 13.8648 7.34959 13 8M9 16C8.13452 16.6491 7.08185 17 6 17H3" 
                stroke={stroke} 
                strokeWidth={strokeWidth} 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    );
}





